const MDAllyHome = (function($) {
    
    const controller = new ScrollMagic.Controller();
    const EO = Elastic.easeOut.config;


 	let	isTesting = false;
 	let nodeCanvas;
 	let heroCanvas;
 	let dataNum = {num:49.4};
 	let currentSection = 0;
 	let heroScene;
 	let isMobile = false;

    const onInit = function() {
    
    	/*const scroll = new LocomotiveScroll({
		    el: $('body')[0],
		    smooth: true
		});
    	console.log( LocomotiveScroll );*/

    	//Scrollbar.init( $('.content-container')[0]);

    	heroCanvas = $( 'section.hero-animation .animation-container canvas');

    	if( heroCanvas.data('lib') ) 
    		initHomeHero();
    	else
    		heroCanvas.data('onReady' , initHomeHero );
		
    	initScrollIndicator();
    	initPageScrollElements();
    }

    function initScrollIndicator() {
    	$('.scroll-indicator .indicator-arrow').mouseover((e)=>{
    		gsap.to( '.scroll-indicator .indicator-arrow svg' , 0.4 , {y:10 , ease:Sine.easeInOut , yoyo:true , repeat:-1} );
    	}).mouseleave((e)=>{
    		gsap.to( '.scroll-indicator .indicator-arrow svg' , 0.2 , {y:0 , ease:Expo.easeOut , overwrite:true } );
    	}).click((e)=>{
    		if( isMobile ) {
    			if( currentSection == 1 ) {
    				gsap.to(window, {duration:0.1, scrollTo: {y:(2000 * 0.26 ) }});
    			} else if( currentSection == 2 ) {
    				gsap.to(window, {duration:0.1, scrollTo: {y:(2000 * 0.55 ) }});
    			} else {
    				gsap.to(window, { duration:1, scrollTo:'section.serve-more' , ease:Expo.easeInOut });
    			}
    		} else {
    			gsap.to(window, { duration:1, scrollTo:'section.serve-more' , ease:Expo.easeInOut });
    		}
    	});
    }
    

    function initHomeHero(m) {
 	
    	const heroS = 'section.hero-animation';
    	
    	const heroAnimationCanvas = $( heroS + ' .animation-container canvas');
    		heroAnimationCanvas.data('exportRoot').onInit();

    	const heroTimeline = heroAnimationCanvas.data('exportRoot').tl;
    		var hero01 = heroTimeline.labels[ 'frame02' ] / heroTimeline.duration();
			var hero02 = heroTimeline.labels[ 'frame03' ] / heroTimeline.duration();
			var hero03 = heroTimeline.labels[ 'end' ] / heroTimeline.duration();


    	const text01 = new SplitText( heroS + ' .item01 h1' , {type:'lines,words' , linesClass:'line' } );
    	const text02 = new SplitText( heroS + ' .item02 h1' , {type:'lines,words' , linesClass:'line' } );
    	const text03 = new SplitText( heroS + ' .item03 h1' , {type:'lines,words' , linesClass:'line' } );
 		
 		const buttonAnimation = gsap.timeline({paused:true} );
 			buttonAnimation.add("start" , "+=0");
 			buttonAnimation.from( '.hero-nav-container .hero-nav .item01 .highlight-inner' , 1 , {y:-42} , "start+=0");
    		
    		buttonAnimation.addPause("start+=2.999");
    		buttonAnimation.add("item01on" , "start+=3");
 			buttonAnimation.to( '.hero-nav-container .hero-nav .item01 .highlight-inner' , 1 , {y:82} , "item01on+=0");
 			buttonAnimation.from( '.hero-nav-container .hero-nav .item02 .highlight-inner' , 1 , {y:-42} , "item01on+=0.3");
    		
    		buttonAnimation.addPause("item01on+=2.999");
    		buttonAnimation.add("item02on" , "item01on+=3");
 			buttonAnimation.to( '.hero-nav-container .hero-nav .item02 .highlight-inner' , 1 , {y:82} , "item02on+=0");
 			buttonAnimation.from( '.hero-nav-container .hero-nav .item03 .highlight-inner' , 1 , {y:-42} , "item02on+=0.3");
    		
    		buttonAnimation.add("item03on" , "item02on+=3" );

    	const textAnimation = gsap.timeline({paused:true});
	    	textAnimation.add("start" , "+=0");
	    	textAnimation.add("frame01" , "start+=0");
	    	textAnimation.from( text01.words, 1.4 , {y:100 , stagger:"0.05" , ease:EO(0.8,1) } , "frame01+=0" );
	    	textAnimation.from(  heroS + ' .item01 p' , 1 , {alpha:0} , "frame01+=0.5" );
	    	textAnimation.addPause("frame01+=2.999");
	    	textAnimation.add("frame02" , "frame01+=3" );
	    	textAnimation.to( text01.words, 0.5 , {y:-100 ,  stagger:"0.02" } , "frame02+=0" );
	    	textAnimation.to(  heroS + ' .item01 p' , 0.5 , {alpha:0} , "frame02+=0" );
	    	textAnimation.from( text02.words, 1.4 , {y:100 , stagger:"0.05" , ease:EO(0.8,1) } , "frame02+=0" );
	    	textAnimation.from(  heroS + ' .item02 p' , 1 , {alpha:0} , "frame02+=0.5" );
			textAnimation.addPause("frame02+=2.999");
	    	textAnimation.add("frame03" , "frame02+=3" );
	    	textAnimation.to( text02.words, 0.5 , {y:-100 ,  stagger:"0.02"} , "frame03+=0" );
	    	textAnimation.to(  heroS + ' .item02 p' , 0.5 , {alpha:0} , "frame03+=0" );
	    	textAnimation.from( text03.words, 1.4 , {y:100 , stagger:"0.05" , ease:EO(0.8,1) } , "frame03+=0" );
	    	textAnimation.from(  heroS + ' .item03 p' , 1 , {alpha:0} , "frame03+=0.5" );

	    	textAnimation.add("end" , "frame03+=3" );
		
		const prog01 = textAnimation.labels[ 'frame02' ] / textAnimation.duration();
		const prog02 = textAnimation.labels[ 'frame03' ] / textAnimation.duration();
		const prog03 = textAnimation.labels[ 'end' ] / textAnimation.duration();

		const dur = 2000;
		const hook = 0;
    	heroScene = new ScrollMagic.Scene({triggerElement: heroS , duration:dur , triggerHook: hook })
			heroScene.setPin( heroS );
			if(isTesting) heroScene.addIndicators({name: "2 (duration: 0)"}); // add indicators (requires plugin)
			heroScene.addTo(controller);
			heroScene.on("progress", (e)=>{
				const sd = e.scrollDirection;
				
				const speed = (sd == 'FORWARD' ) ? 3 :0.000;
				//console.log( sd );
				if( e.progress < 0.25 ) {
					$('.scroll-indicator').css('opacity' , 1 );
					if( currentSection != 1 ) {
						gsap.to( buttonAnimation , speed , {overwrite:true , progress:prog01} );
						gsap.to( textAnimation , speed , {overwrite:true , progress:prog01} );
						( sd == 'FORWARD' || sd == 'PAUSED' ) ? heroTimeline.play('start') : heroTimeline.play('frame03');
						currentSection = 1;
						gsap.to( heroAnimationCanvas , 0.5 , {y:0});
						//console.log('---- frame01 -----');
					} 
				} else if( e.progress >= 0.25 && e.progress < 0.55 ) {
					$('.scroll-indicator').css('opacity' , 1 );
					if( currentSection != 2 ) {
						gsap.to( buttonAnimation ,speed , {overwrite:true , progress:prog02} );
						gsap.to( textAnimation , speed, {overwrite:true , progress:prog02} );
						heroTimeline.play('frame02');
						
						gsap.to( heroAnimationCanvas , 0.5 , {y:(isMobile)? -80 : 0});

						currentSection = 2;
						//console.log('---- frame02 -----');
						///console.log( heroTimeline.progress() );
					}
				} else {
					$('.scroll-indicator').css('opacity' , ( isMobile ) ? 0 : 1 );

					if( currentSection != 3 ) {
						gsap.to( buttonAnimation , speed , {overwrite:true , progress:prog03} );
						gsap.to( textAnimation , speed, {overwrite:true , progress:prog03} );
						heroTimeline.play('frame03');
						currentSection = 3;
						gsap.to( heroAnimationCanvas , 0.5 , {y:0});
						//console.log('---- frame03 -----');
					}
				}
			});
 
		const pinMenu = new ScrollMagic.Scene({triggerElement: 'header .top-bar-main' , duration:dur , triggerHook: hook })
			pinMenu.setPin( 'header .top-bar-main' );
			pinMenu.addTo(controller);
	

		$( heroS + ' .hero-nav .item01 button').click(()=>{
			gsap.to(window, {duration:0.1, scrollTo: {y:(dur * 0.15 ) }});
		});

		$( heroS + ' .hero-nav .item02 button').click(()=>{
			gsap.to(window, {duration:0.1, scrollTo: {y:(dur * 0.26 ) }});
		});

		$( heroS + ' .hero-nav .item03 button').click(()=>{
			gsap.to(window, {duration:0.1, scrollTo: {y:(dur * 0.55 )} });
		});

		
		jQuery('body').css('opacity', 1);

		$(window).resize(()=>{
			heroScene.removePin(true);
			heroScene.refresh();
			heroScene.setPin( heroS );
		});

		$(window).resize( handleWindowResize ).resize();
	}

	function initPageScrollElements() {
		
		/*
		const videoContent = {
			name: 'videocontent',
    		el: 'section.video-with-content',
    		trigger: {triggerElement: 'section.video-with-content' , triggerHook: 0.9 , duration:"100%" },
    		gsap: gsap.to( 'section.video-with-content .content-block' , {y:"+=100"} ),
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: true
    	}
    	videoContent.scene = MDAllyAnimations.add( videoContent );
		*/

    	const impact01Ani = {
			name: 'impact01Ani',
    		el: 'section.impactful-partnership',
    		trigger: {triggerElement: 'section.impactful-partnership' , triggerHook: 0.8 , duration:"200%" },
    		funct: ()=>{ return gsap.fromTo( 'section.impactful-partnership .wp-block-column:first-child' , {y:0} , {y:50 , ease:Power1.easeInOut} ) } ,
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly : true
    	}
    	impact01Ani.scene = MDAllyAnimations.add( impact01Ani );

    	const impact02Ani = {
			name: 'impact02Ani',
    		el: 'section.impactful-partnership',
    		trigger: {triggerElement: 'section.impactful-partnership' , triggerHook: 0.8 , duration:"200%" },
    		funct: ()=>{ return gsap.fromTo( 'section.impactful-partnership .wp-block-column:last-child' , {y:-300} , {y:75 , ease:Power1.easeOut} )} ,
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: true
    	}
    	impact02Ani.scene = MDAllyAnimations.add( impact02Ani );


		const impact01AniInner = {
			name: 'impact01AniInner',
    		el: 'section.impactful-partnership',
    		trigger: {triggerElement: 'section.impactful-partnership' , triggerHook: 0.8 , duration:"200%" },
    		gsap: gsap.fromTo( 'section.impactful-partnership .wp-block-column:first-child img' , {yPercent:-10} , {yPercent:10 , ease:'none'} ),
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: false
    	}
    	impact01AniInner.scene = MDAllyAnimations.add( impact01AniInner );


    	const impact02AniInner = {
			name: 'impact02AniInner',
    		el: 'section.impactful-partnership',
    		trigger: {triggerElement: 'section.impactful-partnership' , triggerHook: 0.8 , duration:"200%" },
    		gsap: gsap.fromTo( 'section.impactful-partnership .wp-block-column:last-child img' , {yPercent:10} , {yPercent:-10 , ease:'none'} ),
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: false
    	}
    	impact02AniInner.scene = MDAllyAnimations.add( impact02AniInner );

    	MDAllyAnimations.update();
	}	


	function handleWindowResize() {
		if( !isMobile &&  $('.mobile-detect').css('display') == 'block' ) {
			isMobile = true;
			if( currentSection == 2 ) gsap.to( 'section.hero-animation .animation-container canvas' , 0.5 , {y:(isMobile)? -80 : 0});
		} else if( isMobile ) {
			isMobile = false;
			gsap.to( 'section.hero-animation .animation-container canvas' , 0.5 , {y:0});
		}

  		let maxHeight = 0;
  		$('section.hero-animation .items .item').each((i,el)=>{
  			const cpH = $(el).find('.copy-set').height();
  			if( cpH > maxHeight ) maxHeight = cpH;
  		});
  		$('section.hero-animation .items').height( maxHeight );

    }

    return {
    	init: onInit,
    }; 

})(jQuery);
